import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../../../data/api';
import videoApi from '../../../../api/videoApi';

export const useSavedVideos = (userData, responseData) => {
	const [savedVideoIds, setSavedVideoIds] = useState([]);

	// Fetch saved video IDs for the user
	useEffect(() => {
		if (userData?.token && userData?.user?.userId) {
			videoApi
				.getAllSavedVideoIds(userData.user.userId)
				.then(res => {
					setSavedVideoIds(res.data.savedVideos);
				})
				.catch(error => {
					console.error('Error fetching saved videos:', error);
				});
		}
	}, [userData.token, userData.user?.userId, responseData]);

	// Handle save/unsave video
	const handleSaveVideo = async (videoId, video) => {
		try {
			const isLiked =
				video.videoDetails?.savedvideo ||
				video.savedvideo ||
				(savedVideoIds?.length > 0 && savedVideoIds?.includes(video?.videoDetails?._id || video?._id));

			if (isLiked) {
				// Unsave the video
				const response = await api.unsaveWishlist(videoId, userData?.token);
				if (response.status === 200) {
					// Update local state
					setSavedVideoIds(prev => prev.filter(id => id !== videoId));
					return false; // Return new like state
				}
			} else {
				// Save the video
				const response = await api.saveWishlist(videoId, userData?.token);
				if (response.status === 200) {
					// Update local state
					setSavedVideoIds(prev => [...prev, videoId]);
					return true; // Return new like state
				}
			}
		} catch (error) {
			console.error('Error saving/unsaving video: ', error);
			toast.error('Failed to update saved status', {
				position: 'top-center',
				duration: 3000
			});
		}
		return null; // Return null if operation failed
	};

	return {
		savedVideoIds,
		handleSaveVideo
	};
};
